import { Box, Card, CardContent, Chip, FormControl, Grid, InputAdornment, OutlinedInput, Stack, Typography } from "@mui/material";
import { getPrimaryColorByAccountId, getThemeByAccountId, styleConstants } from "../../../utils/styleConstants";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/types/rootState";

interface DesktopTicketsProps {
    ticketQuantity: number | null;
    sumTicketQuantity: (ticket: number) => void;
    handleChangeQuantity: (event: React.ChangeEvent<HTMLInputElement>) => void;
    additions: Array<number>,
  }
  
export const MobileTicketsV2: React.FC<DesktopTicketsProps> = ({ ticketQuantity,  handleChangeQuantity,  sumTicketQuantity, additions }) => {
    const accountId = useSelector(({ account }: RootState) => account.id);
    return (
      <Box sx={{ width: '98%' }} mt={2}>
          <Box width={"100%"}>
            <Grid container>
              {additions.map((addition: number) => (
                <Grid item key={addition} xl={6} md={6} lg={6} p={2} sm={6} xs={6}>
                <Card
                  sx={{
                    cursor: "pointer",
                    border: addition !== 20 ? "1px solid secondary.main" : "1px solid green",
                    borderRadius: "10px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    backgroundColor: `${getPrimaryColorByAccountId(accountId)}`,
                  }}
                  onClick={() => sumTicketQuantity(addition)}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 600, color: `${getThemeByAccountId(accountId) === 'dark' ? '#000 !important' : '#FFF !important' }`, }}
                    >
                       {`+${addition}`}
                        <br />
                        {`tickets.`}
                    </Typography>
                  </CardContent>
                </Card>
                </Grid>
              ))}
            </Grid>

          </Box>
          <FormControl sx={{ m: 1, width: "100%" }}>
        <OutlinedInput
          type="number"
          autoFocus
          value={ticketQuantity ?? ""}
          onChange={handleChangeQuantity}
        />
        </FormControl>
      </Box>
    );
}